/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
  "/api/admin/advertisers": {
    get: operations["GetApiAdminAdvertisers"];
  };
  "/api/admin/affiliate-offers": {
    get: operations["GetApiAdminAffiliateOffers"];
    post: operations["PostApiAdminAffiliateOffers"];
  };
  "/api/admin/affiliate-offers/{id}": {
    get: operations["GetApiAdminAffiliateOffersId"];
    patch: operations["PatchApiAdminAffiliateOffersId"];
  };
  "/api/admin/models": {
    get: operations["GetApiAdminModels"];
  };
  "/api/admin/offers": {
    get: operations["GetApiAdminOffers"];
    post: operations["PostApiAdminOffers"];
  };
  "/api/admin/offers-cpa": {
    get: operations["GetApiAdminOffersCpa"];
    post: operations["PostApiAdminOffersCpa"];
  };
  "/api/admin/offers-cpa-clone": {
    post: operations["PostApiAdminOffersCpaClone"];
  };
  "/api/admin/offers-cpa/categories-weights": {
    get: operations["GetApiAdminOffersCpaCategoriesWeights"];
  };
  "/api/admin/offers-cpa/{id}": {
    get: operations["GetApiAdminOffersCpaId"];
    delete: operations["DeleteApiAdminOffersCpaId"];
    patch: operations["PatchApiAdminOffersCpaId"];
  };
  "/api/admin/offers-cpa/{id}/affiliates-rates": {
    get: operations["GetApiAdminOffersCpaIdAffiliatesRates"];
  };
  "/api/admin/offers-cpa/{id}/rules": {
    get: operations["GetApiAdminOffersCpaIdRules"];
    post: operations["PostApiAdminOffersCpaIdRules"];
  };
  "/api/admin/offers-cpa/{id}/rules/{ruleId}": {
    get: operations["GetApiAdminOffersCpaIdRulesRuleId"];
    put: operations["PutApiAdminOffersCpaIdRulesRuleId"];
    delete: operations["DeleteApiAdminOffersCpaIdRulesRuleId"];
  };
  "/api/admin/offers-cpa/{id}/triggers": {
    put: operations["PutApiAdminOffersCpaIdTriggers"];
  };
  "/api/admin/offers/{id}": {
    get: operations["GetApiAdminOffersId"];
    put: operations["PutApiAdminOffersId"];
  };
  "/api/admin/v3/advertisers": {
    get: operations["GetApiAdminV3Advertisers"];
  };
  "/api/admin/v3/affiliate-offers": {
    get: operations["GetApiAdminV3AffiliateOffers"];
    post: operations["PostApiAdminV3AffiliateOffers"];
  };
  "/api/admin/v3/affiliate-offers/{id}": {
    patch: operations["PatchApiAdminV3AffiliateOffersId"];
  };
  "/api/admin/v3/models-configurations/cpa": {
    get: operations["GetApiAdminV3ModelsConfigurationsCpa"];
  };
  "/api/admin/v3/models-configurations/lot": {
    get: operations["GetApiAdminV3ModelsConfigurationsLot"];
  };
  "/api/admin/v3/models-configurations/revenue": {
    get: operations["GetApiAdminV3ModelsConfigurationsRevenue"];
  };
  "/api/admin/v3/models-configurations/spread": {
    get: operations["GetApiAdminV3ModelsConfigurationsSpread"];
  };
  "/api/admin/v3/offers": {
    get: operations["GetApiAdminV3Offers"];
  };
  "/api/admin/v3/offers/{id}": {
    delete: operations["DeleteApiAdminV3OffersId"];
  };
  "/api/admin/v4/offers": {
    get: operations["GetApiAdminV4Offers"];
    post: operations["PostApiAdminV4Offers"];
  };
  "/api/admin/v4/offers/{id}": {
    get: operations["GetApiAdminV4OffersId"];
    put: operations["PutApiAdminV4OffersId"];
    delete: operations["DeleteApiAdminV4OffersId"];
  };
  "/api/admin/v4/offers/{id}/cpa/settings": {
    get: operations["GetApiAdminV4OffersIdCpaSettings"];
    put: operations["PutApiAdminV4OffersIdCpaSettings"];
  };
  "/api/admin/v4/offers/{id}/cpa/triggers": {
    get: operations["GetApiAdminV4OffersIdCpaTriggers"];
    patch: operations["PatchApiAdminV4OffersIdCpaTriggers"];
  };
  "/api/admin/v4/offers/{id}/revenue/levels": {
    get: operations["GetApiAdminV4OffersIdRevenueLevels"];
    patch: operations["PatchApiAdminV4OffersIdRevenueLevels"];
  };
  "/api/admin/v4/offers/{id}/revenue/settings": {
    get: operations["GetApiAdminV4OffersIdRevenueSettings"];
    put: operations["PutApiAdminV4OffersIdRevenueSettings"];
  };
  "/api/admin/v4/offers/{id}/rules": {
    get: operations["GetAdminOfferRulesV4"];
  };
  "/api/admin/v4/offers/{id}/rules/{locale}": {
    delete: operations["DeleteAdminOfferRulesForLocale"];
  };
  "/api/admin/v4/offers/{id}/rules/{section}/{locale}": {
    get: operations["GetAdminOfferRuleV4"];
    patch: operations["UpdateAdminOfferRuleV4"];
  };
  "/api/advertisers": {
    get: operations["GetApiAdvertisers"];
  };
  "/api/advertisers/{id}": {
    get: operations["GetApiAdvertisersId"];
  };
  "/api/advertisers/{id}/attributes": {
    get: operations["GetApiAdvertisersIdAttributes"];
  };
  "/api/advertisers/{id}/countries": {
    get: operations["GetApiAdvertisersIdCountries"];
  };
  "/api/advertisers/{id}/models": {
    get: operations["GetApiAdvertisersIdModels"];
  };
  "/api/affiliate-advertisers/{id}": {
    get: operations["GetApiAffiliateAdvertisersId"];
    patch: operations["PatchApiAffiliateAdvertisersId"];
  };
  "/api/models": {
    get: operations["GetApiModels"];
  };
  "/api/offers/available": {
    get: operations["GetApiOffersAvailable"];
  };
  "/api/offers/unavailable": {
    get: operations["GetApiOffersUnavailable"];
  };
  "/api/offers/{id}": {
    get: operations["GetApiOffersId"];
  };
  "/api/offers/{id}/activation": {
    get: operations["GetApiOffersIdActivation"];
  };
  "/api/offers/{id}/advertiser": {
    get: operations["GetApiOffersIdAdvertiser"];
  };
  "/api/offers/{id}/cpa-rates": {
    get: operations["GetApiOffersIdCpaRates"];
  };
  "/api/offers/{id}/marketing-rules-accept": {
    post: operations["PostApiOffersIdMarketingRulesAccept"];
  };
  "/api/offers/{id}/rates": {
    get: operations["GetApiOffersIdRates"];
  };
  "/api/offers/{id}/traffic-sources": {
    post: operations["PostApiOffersIdTrafficSources"];
  };
  "/api/v2/offers": {
    get: operations["GetApiV2Offers"];
  };
  "/api/v2/offers/activations": {
    get: operations["GetApiV2OffersActivations"];
  };
  "/api/v2/offers/favorite": {
    post: operations["PostApiV2OffersFavorite"];
    delete: operations["DeleteApiV2OffersFavorite"];
  };
  "/api/v2/offers/{AdvertModel}": {
    get: operations["GetApiV2OffersAdvertModel"];
  };
  "/api/v2/offers/{AdvertModel}/activation": {
    get: operations["GetApiV2OffersAdvertModelActivation"];
  };
  "/api/v2/offers/{AdvertModel}/advertiser": {
    get: operations["GetApiV2OffersAdvertModelAdvertiser"];
  };
  "/api/v2/offers/{AdvertModel}/cpa-rates": {
    get: operations["GetApiV2OffersAdvertModelCpaRates"];
  };
  "/api/v2/offers/{AdvertModel}/cpa-triggers": {
    get: operations["GetApiV2OffersAdvertModelCpaTriggers"];
  };
  "/api/v2/offers/{AdvertModel}/marketing-rules-accept": {
    post: operations["PostApiV2OffersAdvertModelMarketingRulesAccept"];
  };
  "/api/v2/offers/{AdvertModel}/rates": {
    get: operations["GetApiV2OffersAdvertModelRates"];
  };
  "/api/v2/offers/{AdvertModel}/revenue-rated-view": {
    get: operations["GetApiV2OffersAdvertModelRevenueRatedView"];
  };
  "/api/v2/offers/{AdvertModel}/rules": {
    get: operations["GetOfferRules"];
  };
  "/api/v2/offers/{AdvertModel}/rules/{section}/{locale}": {
    get: operations["GetOfferRule"];
  };
  "/api/v2/offers/{AdvertModel}/traffic-sources": {
    post: operations["PostApiV2OffersAdvertModelTrafficSources"];
  };
  "/healthcheck": {
    get: operations["GetHealthcheck"];
  };
}

export interface components {
  schemas: {
    ActiveTradersAttractedCondition: components["schemas"]["BaseCondition"] & {
      actualCnt: number;
      expectedCnt: number;
    };
    Advertiser: {
      alias: string;
      description: string;
      id: number;
      links: components["schemas"]["AdvertiserLinks"];
      logo: string;
      name: string;
      platforms: string[];
      regions: string[];
      restrictionGrade: number;
      shortDescription: string;
      theme: string[];
      website: string;
    };
    AdvertiserAdmin: {
      alias: string;
      id: number;
      name: string;
    };
    AdvertiserAdminV3: {
      id: number;
      logo: string;
      name: string;
      name_for_aff: string;
      site_id: number;
    };
    AdvertiserAttribute: {
      title: string;
      type: string;
      value: string;
    };
    AdvertiserAttributesCollection: {
      data: components["schemas"]["AdvertiserAttribute"][];
    };
    AdvertiserCountriesCollection: {
      data: components["schemas"]["Country"][];
    };
    AdvertiserLinks: {
      type: string;
      url: string;
    }[];
    AdvertisersAdminCollection: {
      data: components["schemas"]["AdvertiserAdmin"][];
    };
    AdvertisersAdminCollectionV3: {
      data: components["schemas"]["AdvertiserAdminV3"][];
    };
    AdvertisersCollection: {
      data: components["schemas"]["Advertiser"][];
    };
    AffiliateAdvertiser: {
      advertiserId: number;
      affId: number;
      backlinkUrl: string;
    };
    AffiliateAdvertiserPatch: {
      backlinkUrl?: string;
    };
    AffiliateOfferAdmin: {
      accrualStatus: components["schemas"]["OfferAccrualStatus"];
      advertiserId: number;
      affId: number;
      availabilityStatus: components["schemas"]["OfferAvailabilityStatus"];
      id: number;
      modelId: string;
      offerId: number;
      paymentsStatus: components["schemas"]["OfferPaymentStatus"];
      trafficSources: components["schemas"]["OfferTrafficSources"];
      trafficSourcesStatus: components["schemas"]["OfferTrafficSourcesStatus"];
      trafficStatus: components["schemas"]["OfferTrafficStatus"];
    };
    AffiliateOfferAdminCollection: components["schemas"]["PaginatedCollection"] & {
      data: components["schemas"]["AffiliateOfferAdmin"][];
    };
    AffiliateOfferAdminCollectionV3: {
      data: components["schemas"]["AffiliateOfferAdminV3"][];
    };
    AffiliateOfferAdminPatch: {
      accrualStatus?: components["schemas"]["OfferAccrualStatus"];
      availabilityStatus?: components["schemas"]["OfferAvailabilityStatus"];
      offerId?: number;
      paymentsStatus?: components["schemas"]["OfferPaymentStatus"];
      trafficSources?: components["schemas"]["OfferTrafficSources"];
      trafficSourcesStatus?: components["schemas"]["OfferTrafficSourcesStatus"];
      trafficStatus?: components["schemas"]["OfferTrafficStatus"];
    };
    AffiliateOfferAdminPatchV3: {
      accrual_status?: components["schemas"]["OfferAccrualStatus"];
      availability_status?: components["schemas"]["OfferAvailabilityStatus"];
      offer_id?: number;
      payments_status?: components["schemas"]["OfferPaymentStatus"];
      traffic_sources?: components["schemas"]["OfferTrafficSources"];
      traffic_sources_status?: components["schemas"]["OfferTrafficSourcesStatus"];
      traffic_status?: components["schemas"]["OfferTrafficStatus"];
    };
    AffiliateOfferAdminPost: {
      accrualStatus: components["schemas"]["OfferAccrualStatus"];
      advertiserId: number;
      affId: number;
      availabilityStatus: components["schemas"]["OfferAvailabilityStatus"];
      modelId: string;
      offerId: number;
      paymentsStatus: components["schemas"]["OfferPaymentStatus"];
      trafficSources?: components["schemas"]["OfferTrafficSources"];
      trafficSourcesStatus: components["schemas"]["OfferTrafficSourcesStatus"];
      trafficStatus: components["schemas"]["OfferTrafficStatus"];
    };
    AffiliateOfferAdminPostV3: {
      accrual_status: components["schemas"]["OfferAccrualStatus"];
      advertiser_id: number;
      aff_id: number;
      availability_status: components["schemas"]["OfferAvailabilityStatus"];
      model_id: string;
      offer_id: number;
      payments_status: components["schemas"]["OfferPaymentStatus"];
      requirements: components["schemas"]["OfferActivationRequirement"][];
      traffic_sources?: components["schemas"]["OfferTrafficSources"];
      traffic_sources_status?: components["schemas"]["OfferTrafficSourcesStatus"];
      traffic_status: components["schemas"]["OfferTrafficStatus"];
    };
    AffiliateOfferAdminV3: {
      accrual_status: components["schemas"]["OfferAccrualStatus"];
      activation: components["schemas"]["OfferActivation"];
      advertiser_id: number;
      aff_id: number;
      author_id?: number;
      availability_status: components["schemas"]["OfferAvailabilityStatus"];
      id: number;
      model_id: string;
      offer: components["schemas"]["OfferAdminV3"];
      payments_status: components["schemas"]["OfferPaymentStatus"];
      traffic_sources: components["schemas"]["OfferTrafficSources"];
      traffic_sources_status: components["schemas"]["OfferTrafficSourcesStatus"];
      traffic_status: components["schemas"]["OfferTrafficStatus"];
      /** Format: date-time */
      updated: string;
    };
    AntiFraudChecksCondition: components["schemas"]["BaseCondition"];
    BaseCondition: {
      isSatisfied: boolean;
      type: string;
    } & {
      payload: unknown;
    };
    Country: {
      code: string;
      name: string;
    };
    CountryCode: string;
    Error: {
      error?: components["schemas"]["ErrorItem"];
    };
    ErrorField: {
      /** @description translation key of error */
      key?: string;
      params?: { [key: string]: string };
    };
    /**
     * @example {
     *   "common": {
     *     "key": "api_error.rate_limit",
     *     "params": {
     *       "until": 1551908007642
     *     }
     *   },
     *   "fields": {
     *     "name": {
     *       "key": "api_error.validation_is_int",
     *       "params": {
     *         "value": "whatever was passed as non int"
     *       }
     *     }
     *   }
     * }
     */
    ErrorItem: {
      _global?: components["schemas"]["ErrorField"];
      fields?: { [key: string]: components["schemas"]["ErrorField"] };
    };
    Healthcheck: {
      alive: boolean;
    };
    KycPassedCondition: components["schemas"]["BaseCondition"];
    MarketingRulesAcceptedCondition: components["schemas"]["BaseCondition"];
    ModelConfiguration: {
      id: number;
      name: string;
    };
    ModelConfigurationCpa: components["schemas"]["ModelConfiguration"];
    ModelConfigurationLot: components["schemas"]["ModelConfiguration"];
    ModelConfigurationRevenue: components["schemas"]["ModelConfiguration"];
    ModelConfigurationSpread: components["schemas"]["ModelConfiguration"];
    ModelsCollection: {
      data: {
        id: string;
        name: string;
      }[];
    };
    ModelsConfigurationsCpaCollection: {
      data: components["schemas"]["ModelConfigurationCpa"][];
    };
    ModelsConfigurationsLotCollection: {
      data: components["schemas"]["ModelConfigurationLot"][];
    };
    ModelsConfigurationsRevenueCollection: {
      data: components["schemas"]["ModelConfigurationRevenue"][];
    };
    ModelsConfigurationsSpreadCollection: {
      data: components["schemas"]["ModelConfigurationSpread"][];
    };
    /** @deprecated */
    Money: {
      amount: string;
    };
    /** Format: double */
    MoneyAmount: number;
    MoneyV4: {
      amount: components["schemas"]["MoneyAmount"];
      currency: string;
    };
    Offer: {
      advertiser: components["schemas"]["Advertiser"];
      /**
       * @deprecated
       * @description use advertiser field
       */
      advertiserId: number;
      /** @enum {string} */
      availability: "available" | "unavailable";
      ftdCount: number;
      icon: string;
      id: number;
      isFavorite: boolean;
      isTrial: boolean;
      links: components["schemas"]["AdvertiserLinks"];
      marketingRulesAccepted: boolean;
      model: string;
      /** @deprecated */
      name: string;
      paymentsStatus: components["schemas"]["OfferPaymentStatus"];
      rate: string;
      rateDescription: string;
      regions: string[];
      restrictionGrade: number;
      rules: components["schemas"]["OfferRules"];
      shortName: string;
      trafficStatus: components["schemas"]["OfferTrafficStatus"];
      /** @enum {string} */
      version: "v1" | "v2";
    };
    /** @enum {string} */
    OfferAccrualStatus: "enabled" | "disabled" | "suspended";
    OfferActivation: {
      accountConditions: (
        | components["schemas"]["KycPassedCondition"]
        | components["schemas"]["MarketingRulesAcceptedCondition"]
        | components["schemas"]["TrafficSourcesVerifiedCondition"]
        | components["schemas"]["BaseCondition"]
      )[];
      paymentsConditions: (
        | components["schemas"]["ActiveTradersAttractedCondition"]
        | components["schemas"]["AntiFraudChecksCondition"]
        | components["schemas"]["BaseCondition"]
      )[];
      paymentsStatus: components["schemas"]["OfferPaymentStatus"];
      trafficStatus: components["schemas"]["OfferTrafficStatus"];
    };
    /** @enum {string} */
    OfferActivationRequirement:
      | "verify_kyc"
      | "verify_traffic_sources"
      | "accept_marketing_rules";
    OfferActivationTrafficSourcesPost: {
      sources: components["schemas"]["OfferTrafficSources"];
    };
    OfferAdmin: {
      advertiserId: number;
      created: string;
      detailsId: number;
      id: number;
      modelId: string;
      /** @deprecated */
      name: string;
      nameForAff: string;
      rate: string;
      rateDescription: string;
      rules: components["schemas"]["OfferRules"];
      shortName: string;
      updated: string;
    };
    OfferAdminCpaSettingsPutV4: {
      /** @default 30 */
      conversion_period_days: number;
      /** @default 0 */
      deposit_period_days: number;
    };
    OfferAdminCpaSettingsResponseV4: {
      /** @default 30 */
      conversion_period_days: number;
      /** @default 0 */
      deposit_period_days: number;
    };
    OfferAdminCpaTriggerPatchV4: {
      countries: components["schemas"]["CountryCode"][];
      /** Format: int */
      deals_count: number;
      default_price: components["schemas"]["MoneyAmount"];
      deposit_amount: components["schemas"]["MoneyAmount"];
      platforms: components["schemas"]["OfferCpaPlatform"][];
      turnover_amount: components["schemas"]["MoneyAmount"];
    };
    OfferAdminCpaTriggerV4: {
      countries: components["schemas"]["CountryCode"][];
      /** Format: int */
      deals_count: number;
      default_price: components["schemas"]["MoneyV4"];
      deposit_amount: components["schemas"]["MoneyV4"];
      platforms: components["schemas"]["OfferCpaPlatform"][];
      turnover_amount: components["schemas"]["MoneyV4"];
    };
    OfferAdminCpaTriggersPatchV4: {
      triggers: components["schemas"]["OfferAdminCpaTriggerPatchV4"][];
    };
    OfferAdminCpaTriggersResponseV4: {
      triggers: components["schemas"]["OfferAdminCpaTriggerV4"][];
    };
    OfferAdminLevelPatchV4: {
      /** Format: double */
      brand_fee_percent: number;
      ftd_count: number;
      /** Format: double */
      revenue_share_percent: number;
      trader_age: number;
    };
    OfferAdminLevelV4: {
      /** Format: double */
      brand_fee_percent: number;
      ftd_count: number;
      id: number;
      /** Format: double */
      revenue_share_percent: number;
      trader_age: number;
    };
    OfferAdminOfferRulesResponseV4: {
      data: components["schemas"]["OfferAdminRuleV4"][];
    };
    OfferAdminPostV4: {
      advertiser_id: number;
      model: string;
      name: string;
      short_name_for_aff: string;
    };
    OfferAdminPutV4: {
      comment?: string;
      /** @default 0 */
      ftd_count?: number;
      is_trial?: boolean;
      name: string;
      rate: string;
      short_name_for_aff: string;
    };
    OfferAdminRevenueLevelsPatchV4: {
      triggers?: components["schemas"]["OfferAdminLevelPatchV4"][];
    };
    OfferAdminRevenueLevelsResponseV4: {
      levels: components["schemas"]["OfferAdminLevelV4"][];
    };
    OfferAdminRevenueSettingsPutV4: {
      delay_in_days: number;
      /** @enum {string} */
      tariff: "united" | "separated";
      /** Format: double */
      volume_percent: number;
    };
    OfferAdminRevenueSettingsResponseV4: {
      delay_in_days: number;
      /** @enum {string} */
      tariff: "united" | "separated";
      /** Format: double */
      volume_percent: number;
    };
    OfferAdminRuleItem: {
      body: string;
      section: components["schemas"]["OfferAdminRuleSectionType"];
    };
    OfferAdminRuleSection: {
      is_populated: boolean;
      section: components["schemas"]["OfferAdminRuleSectionType"];
    };
    /** @enum {string} */
    OfferAdminRuleSectionType:
      | "generalRestrictions"
      | "marketingGuidelines"
      | "trafficTypes"
      | "negativeKeywords"
      | "appsGuidelines"
      | "paymentTerms";
    OfferAdminRuleV4: {
      locale: string;
      sections: components["schemas"]["OfferAdminRuleSection"][];
    };
    OfferAdminV3: {
      advertiser_id: number;
      configuration_id: number;
      /** Format: date-time */
      created_at: string;
      /** Format: date-time */
      deleted_at?: string;
      id: number;
      model_id: string;
      name: string;
      rate: string;
      rate_description: string;
      rules: components["schemas"]["OfferRules"];
      short_name: string;
      /** Format: date-time */
      updated_at: string;
    };
    OfferAdminV4: {
      advertiser_id: number;
      comment: string;
      /** Format: date-time */
      created_at: string;
      /** Format: int64 */
      ftd_count: number;
      id: number;
      is_deleted: boolean;
      is_trial: boolean;
      model: string;
      name: string;
      rate: string;
      short_name_for_aff: string;
      /** Format: date-time */
      updated_at: string;
      /** Format: int64 */
      users_count: number;
    };
    OfferAdvertiser: {
      description: string;
      id: number;
      logo: string;
      name: string;
      platforms: string[];
      regions: string[];
      restrictionGrade: number;
      theme: string[];
      website: string;
    };
    /** @enum {string} */
    OfferAvailabilityStatus: "hidden" | "enabled" | "disabled" | "suspended";
    OfferCpaAdmin: {
      advertisers: components["schemas"]["AdvertiserAdmin"][];
      affsCount: number;
      /**
       * Format: int64
       * @description author ID
       */
      authorId: number;
      categories: components["schemas"]["OfferCpaCategoryAdmin"][];
      conversionPeriodDays: number;
      created: string;
      deleted?: string;
      depositPeriodDays: number;
      description?: string;
      id: number;
      name: string;
      triggers: components["schemas"]["OfferCpaCategoryTriggerAdmin"][];
      updated: string;
    };
    OfferCpaAdminClone: {
      offerId: number;
    } & components["schemas"]["OfferCpaAdminPost"];
    OfferCpaAdminPatch: {
      conversionPeriodDays?: number;
      depositPeriodDays?: number;
      description?: string;
      name?: string;
    };
    OfferCpaAdminPost: {
      /** @default 30 */
      conversionPeriodDays: number;
      /** @default 0 */
      depositPeriodDays: number;
      description?: string;
      name: string;
      /** @default 1 */
      qtyCategories: number;
    };
    OfferCpaAffiliateCategory: {
      minDepositAmount?: components["schemas"]["Money"];
      name: string;
      weight: components["schemas"]["OfferCpaCategoryWeight"];
    } & {
      depositAmount: unknown;
    };
    /** @deprecated */
    OfferCpaAffiliateRate: {
      category: components["schemas"]["OfferCpaAffiliateCategory"];
      country: components["schemas"]["Country"];
      platform: components["schemas"]["OfferCpaPlatform"];
      price: components["schemas"]["Money"];
    };
    /** @deprecated */
    OfferCpaAffiliateRatesCollection: {
      categories: components["schemas"]["OfferCpaAffiliateCategory"][];
      data: components["schemas"]["OfferCpaAffiliateRate"][];
    };
    OfferCpaCategoryAdmin: {
      /** Format: int */
      id: number;
      name: string;
      weight: components["schemas"]["OfferCpaCategoryWeight"];
    };
    OfferCpaCategoryTriggerAdmin: {
      category: components["schemas"]["OfferCpaCategoryAdmin"];
      /** Format: double */
      defaultPrice: number;
      /** Format: double */
      depositAmount: number;
      id: number;
      /** Format: double */
      leadTriggerAmount: number;
      /** Format: int */
      leadTriggerCount: number;
      platform: components["schemas"]["OfferCpaPlatform"];
    };
    OfferCpaCategoryWeight: number;
    /** @enum {string} */
    OfferCpaPlatform: "mobile" | "desktop";
    OfferCpaRuleAdmin: {
      countries: components["schemas"]["Country"][];
      created: string;
      /** Format: int */
      id: number;
      platforms: components["schemas"]["OfferCpaPlatform"][];
      positionWeight: number;
      prices: components["schemas"]["OfferCpaRulePriceAdmin"][];
      updated: string;
    };
    OfferCpaRuleAdminPost: {
      countries: string[];
      platforms: components["schemas"]["OfferCpaPlatform"][];
      positionWeight: number;
      prices: components["schemas"]["OfferCpaRulePricePostAdmin"][];
    };
    OfferCpaRuleAdminPut: {
      countries: string[];
      platforms: components["schemas"]["OfferCpaPlatform"][];
      positionWeight: number;
      prices: components["schemas"]["OfferCpaRulePricePostAdmin"][];
    };
    OfferCpaRulePriceAdmin: {
      /** Format: int */
      categoryId: number;
      /** Format: double */
      price: number;
    };
    OfferCpaRulePricePostAdmin: {
      /** Format: int */
      categoryId: number;
      /** Format: int */
      price: number;
    };
    OfferCpaTriggerV2: {
      countries: components["schemas"]["CountryCode"][];
      default_price: components["schemas"]["MoneyV4"];
      deposit_amount: components["schemas"]["MoneyV4"];
      platforms: components["schemas"]["OfferCpaPlatform"][];
    };
    OfferCpaTriggersAdminBulkPut: {
      triggers: components["schemas"]["OfferCpaTriggersAdminBulkTrigger"][];
    };
    OfferCpaTriggersAdminBulkTrigger: {
      /**
       * Format: int
       * @default 0
       */
      defaultPrice: number;
      /**
       * Format: int
       * @default 0
       */
      depositAmount: number;
      /**
       * Format: int
       * @default 0
       */
      leadTriggerAmount: number;
      /**
       * Format: int
       * @default 0
       */
      leadTriggerCount: number;
      /** Format: integer */
      triggerId: number;
    };
    OfferCpaTriggersResponseV2: {
      triggers: components["schemas"]["OfferCpaTriggerV2"][];
    };
    OfferCpaUniqueCategoryWeight: {
      name: string;
      weight: components["schemas"]["OfferCpaCategoryWeight"];
    };
    OfferCpaUniqueCategoryWeightCollection: {
      data: components["schemas"]["OfferCpaUniqueCategoryWeight"][];
    };
    OfferFavourite: {
      offerId: number;
    };
    /** @enum {string} */
    OfferPaymentStatus: "enabled" | "disabled" | "suspended";
    OfferPost: components["schemas"]["OfferPut"] & {
      advertiserId: number;
      detailsId: number;
      modelId: string;
    };
    OfferPut: {
      detailsId: number;
      name: string;
      nameForAff: string;
      rate: string;
      rateDescription: string;
      rules: components["schemas"]["OfferRules"];
      shortName: string;
    };
    /**
     * @deprecated
     * @description legacy affiliate rates
     */
    OfferRatesCollection: {
      data: {
        country: components["schemas"]["Country"];
        price: {
          android: components["schemas"]["Money"];
          desktop: components["schemas"]["Money"];
          ios: components["schemas"]["Money"];
        };
      }[];
    };
    OfferRevenueRatedView: {
      /** Format: int64 */
      current_ftd_count: number;
      /** Format: double */
      current_revenue_share_percent: number;
      levels: components["schemas"]["OfferRevenueRatedViewLevel"][];
    };
    OfferRevenueRatedViewLevel: {
      /** Format: int64 */
      ftd_count: number;
      /** Format: double */
      revenue_share_percent: number;
    };
    OfferRule: {
      locale: string;
      sections: components["schemas"]["OfferRuleSection"][];
    };
    OfferRuleItem: {
      body: string;
      section: components["schemas"]["OfferRuleSectionType"];
    };
    OfferRuleSection: {
      is_populated: boolean;
      section: components["schemas"]["OfferRuleSectionType"];
    };
    /** @enum {string} */
    OfferRuleSectionType:
      | "generalRestrictions"
      | "marketingGuidelines"
      | "trafficTypes"
      | "negativeKeywords"
      | "appsGuidelines"
      | "paymentTerms";
    OfferRules: {
      appsGuidelines?: string;
      generalRestrictions?: string;
      marketingGuidelines?: string;
      negativeKeywords?: string;
      paymentTerms?: string;
      trafficTypes?: string;
    };
    OfferRulesResponse: {
      data: components["schemas"]["OfferRule"][];
    };
    OfferTrafficSources: string[];
    /** @enum {string} */
    OfferTrafficSourcesStatus:
      | "not_verified"
      | "pending"
      | "approved"
      | "rejected";
    /** @enum {string} */
    OfferTrafficStatus: "enabled" | "disabled" | "suspended";
    OfferV2: {
      advertiserId: number;
      /** @enum {string} */
      availability: "available" | "unavailable";
      ftdCount: number;
      id: number;
      isFavourite: boolean;
      isTrial: boolean;
      marketingRulesAccepted: boolean;
      model: string;
      /** @deprecated */
      name: string;
      paymentsStatus: components["schemas"]["OfferPaymentStatus"];
      rate: string;
      rules: components["schemas"]["OfferRules"];
      shortName: string;
      trafficStatus: components["schemas"]["OfferTrafficStatus"];
    };
    OfferV4PostResponse: {
      /** Format: int */
      id: number;
    };
    OffersActivationsCollection: {
      data: components["schemas"]["OffersActivationsCollectionItem"][];
    };
    OffersActivationsCollectionItem: {
      offerId: number;
      paymentConditions: components["schemas"]["OfferActivation"];
    };
    OffersAdminCollection: components["schemas"]["PaginatedCollection"] & {
      data: components["schemas"]["OfferAdmin"][];
    };
    OffersAdminCollectionV3: components["schemas"]["PaginatedCollection"] & {
      data: components["schemas"]["OfferAdminV3"][];
    };
    OffersAdminCollectionV4: components["schemas"]["PaginatedCollection"] & {
      data: components["schemas"]["OfferAdminV4"][];
    };
    OffersCollection: {
      data: components["schemas"]["Offer"][];
    };
    OffersCollectionV2: {
      data: components["schemas"]["OfferV2"][];
    };
    OffersCpaAdminCollection: components["schemas"]["PaginatedCollection"] & {
      data: components["schemas"]["OfferCpaAdmin"][];
    };
    OffersCpaRulesAdminCollection: components["schemas"]["PaginatedCollection"] & {
      data: components["schemas"]["OfferCpaRuleAdmin"][];
    };
    PaginatedCollection: {
      totalCount: number;
    };
    /** @enum {string} */
    SwitcherWithSuspension: "enabled" | "disabled" | "suspended";
    TrafficSourcesVerifiedCondition: components["schemas"]["BaseCondition"] & {
      ticketId: string;
      trafficSources: string[];
      trafficSourcesStatus: components["schemas"]["OfferTrafficSourcesStatus"];
    };
  };
  responses: {
    /** Success response that contains entity id */
    AffiliateOfferAdminPostV3Response: {
      content: {
        "application/json": {
          /** Format: int64 */
          id: number;
        };
      };
    };
  };
  parameters: {
    /**
     * @description Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa']
     * @example exnova_revenue
     */
    AdvertModel: string;
    /** @description The id of the advertiser */
    AdvertiserId: number;
    /** @description The id of the affiliate */
    AffId: number;
    /** @description The id of the affiliate */
    AffIdV2: number;
    /** @description The id of the affiliate offer */
    AffiliateOfferId: number;
    /** @description The brand id */
    BrandId: number;
    FilterByAdvertisers: number[];
    FilterByCategories: components["schemas"]["OfferCpaCategoryWeight"][];
    FilterByCountries: string[];
    FilterByDeleted: boolean;
    FilterByDeletedV2: boolean;
    FilterByDeletedV4: boolean;
    FilterByIds: number[];
    IsTrial: boolean;
    /** @description Locale information */
    LocaleId: string;
    /** @description The id of the cpa offer */
    OfferCpaId: number;
    /** @description The id of the cpa offer rule */
    OfferCpaRuleId: number;
    /** @description The id of the offer */
    OfferId: number;
    OffersCpaFilterByMaxPrice: number;
    OffersCpaFilterByMinPrice: number;
    OffersCpaFilterByName: string;
    OffersCpaFilterByPlatforms: components["schemas"]["OfferCpaPlatform"][];
    OffersCpaRequiredFilterByPlatform: components["schemas"]["OfferCpaPlatform"];
    OffersCpaSortBy: "id" | "name" | "affsCount" | "created";
    OffersFilterByAdvertiser: number;
    OffersFilterByAdvertiserIds: number[];
    OffersFilterByAdvertisers: number[];
    OffersFilterByAvailabilityStatus: "unavailable" | "available";
    OffersFilterByConfigurationId: number[];
    OffersFilterByDetailId: number;
    /** @description for favourite list */
    OffersFilterByIsFavourite: boolean;
    OffersFilterByModel: string;
    OffersFilterByModels: string[];
    OffersFilterByModelsV3: string[];
    OffersFilterByModelsV4: string[];
    OffersFilterByRegions: string[];
    OffersSearch: string;
    OffersSortBy: "id" | "name" | "created_at";
    /** @description size of slice */
    PageSizeParam: number;
    PageSkipParam: number;
    /** @description The name of the section */
    SectionId: components["schemas"]["OfferRuleSectionType"];
    /** @description The id of the site */
    SiteId: number;
    SortOrder: "asc" | "desc";
    WithDeleted: boolean;
    WithHidden: boolean;
  };
  requestBodies: {
    AffiliateAdvertiserPatchBody: {
      content: {
        "application/json": components["schemas"]["AffiliateAdvertiserPatch"];
      };
    };
    AffiliateOfferAdminPatchBody: {
      content: {
        "application/json": components["schemas"]["AffiliateOfferAdminPatch"];
      };
    };
    AffiliateOfferAdminPatchV3Body: {
      content: {
        "application/json": components["schemas"]["AffiliateOfferAdminPatchV3"];
      };
    };
    AffiliateOfferAdminPostBody: {
      content: {
        "application/json": components["schemas"]["AffiliateOfferAdminPost"];
      };
    };
    AffiliateOfferAdminPostV3Body: {
      content: {
        "application/json": components["schemas"]["AffiliateOfferAdminPostV3"];
      };
    };
    OfferActivationTrafficSourcesPostBody: {
      content: {
        "application/json": components["schemas"]["OfferActivationTrafficSourcesPost"];
      };
    };
    OfferAdminCpaSettingsPutBodyV4: {
      content: {
        "application/json": components["schemas"]["OfferAdminCpaSettingsPutV4"];
      };
    };
    OfferAdminCpaTriggersPatchBodyV4: {
      content: {
        "application/json": components["schemas"]["OfferAdminCpaTriggersPatchV4"];
      };
    };
    OfferAdminPostBodyV4: {
      content: {
        "application/json": components["schemas"]["OfferAdminPostV4"];
      };
    };
    OfferAdminPutBodyV4: {
      content: {
        "application/json": components["schemas"]["OfferAdminPutV4"];
      };
    };
    OfferAdminRevenueLevelsPatchBodyV4: {
      content: {
        "application/json": components["schemas"]["OfferAdminRevenueLevelsPatchV4"];
      };
    };
    OfferAdminRevenueSettingsPutBodyV4: {
      content: {
        "application/json": components["schemas"]["OfferAdminRevenueSettingsPutV4"];
      };
    };
    OfferCpaAdminCloneBody: {
      content: {
        "application/json": components["schemas"]["OfferCpaAdminClone"];
      };
    };
    OfferCpaAdminPatchBody: {
      content: {
        "application/json": components["schemas"]["OfferCpaAdminPatch"];
      };
    };
    OfferCpaAdminPostBody: {
      content: {
        "application/json": components["schemas"]["OfferCpaAdminPost"];
      };
    };
    OfferCpaRuleAdminPostBody: {
      content: {
        "application/json": components["schemas"]["OfferCpaRuleAdminPost"];
      };
    };
    OfferCpaRuleAdminPutBody: {
      content: {
        "application/json": components["schemas"]["OfferCpaRuleAdminPut"];
      };
    };
    OfferCpaTriggersAdminBulkPutBody: {
      content: {
        "application/json": components["schemas"]["OfferCpaTriggersAdminBulkPut"];
      };
    };
    OfferIdPostBody: {
      content: {
        "application/json": components["schemas"]["OfferFavourite"];
      };
    };
    OfferPostBody: {
      content: {
        "application/json": components["schemas"]["OfferPost"];
      };
    };
    OfferPutBody: {
      content: {
        "application/json": components["schemas"]["OfferPut"];
      };
    };
  };
}

export interface operations {
  GetApiAdminAdvertisers: {
    parameters: {
      query: {
        /** The brand id */
        brandId?: components["parameters"]["BrandId"];
        withDeleted?: components["parameters"]["WithDeleted"];
        withHidden?: components["parameters"]["WithHidden"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["AdvertisersAdminCollection"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiAdminAffiliateOffers: {
    parameters: {
      query: {
        /** The id of the affiliate */
        affId?: components["parameters"]["AffId"];
        skip?: components["parameters"]["PageSkipParam"];
        /** size of slice */
        first?: components["parameters"]["PageSizeParam"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["AffiliateOfferAdminCollection"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  PostApiAdminAffiliateOffers: {
    responses: {
      /** Success */
      201: unknown;
      /** Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
    requestBody: components["requestBodies"]["AffiliateOfferAdminPostBody"];
  };
  GetApiAdminAffiliateOffersId: {
    parameters: {
      path: {
        /** The id of the affiliate offer */
        id: components["parameters"]["AffiliateOfferId"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["AffiliateOfferAdmin"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  PatchApiAdminAffiliateOffersId: {
    parameters: {
      path: {
        /** The id of the affiliate offer */
        id: components["parameters"]["AffiliateOfferId"];
      };
    };
    responses: {
      /** Success */
      204: never;
      /** Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
    requestBody: components["requestBodies"]["AffiliateOfferAdminPatchBody"];
  };
  GetApiAdminModels: {
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["ModelsCollection"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiAdminOffers: {
    parameters: {
      query: {
        skip?: components["parameters"]["PageSkipParam"];
        /** size of slice */
        first?: components["parameters"]["PageSizeParam"];
        advertiserId?: components["parameters"]["OffersFilterByAdvertiser"];
        modelId?: components["parameters"]["OffersFilterByModel"];
        detailId?: components["parameters"]["OffersFilterByDetailId"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["OffersAdminCollection"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  PostApiAdminOffers: {
    responses: {
      /** Success */
      201: unknown;
      /** Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
    requestBody: components["requestBodies"]["OfferPostBody"];
  };
  GetApiAdminOffersCpa: {
    parameters: {
      query: {
        skip?: components["parameters"]["PageSkipParam"];
        /** size of slice */
        first?: components["parameters"]["PageSizeParam"];
        name?: components["parameters"]["OffersCpaFilterByName"];
        advertisers?: components["parameters"]["FilterByAdvertisers"];
        hideDeleted?: components["parameters"]["FilterByDeleted"];
        countries?: components["parameters"]["FilterByCountries"];
        platforms?: components["parameters"]["OffersCpaFilterByPlatforms"];
        categories?: components["parameters"]["FilterByCategories"];
        minPrice?: components["parameters"]["OffersCpaFilterByMinPrice"];
        maxPrice?: components["parameters"]["OffersCpaFilterByMaxPrice"];
        sort?: components["parameters"]["OffersCpaSortBy"];
        order?: components["parameters"]["SortOrder"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["OffersCpaAdminCollection"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  PostApiAdminOffersCpa: {
    responses: {
      /** Success */
      201: unknown;
      /** Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
    requestBody: components["requestBodies"]["OfferCpaAdminPostBody"];
  };
  PostApiAdminOffersCpaClone: {
    responses: {
      /** Success */
      201: unknown;
      /** Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
    requestBody: components["requestBodies"]["OfferCpaAdminCloneBody"];
  };
  GetApiAdminOffersCpaCategoriesWeights: {
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["OfferCpaUniqueCategoryWeightCollection"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiAdminOffersCpaId: {
    parameters: {
      path: {
        /** The id of the cpa offer */
        id: components["parameters"]["OfferCpaId"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["OfferCpaAdmin"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  DeleteApiAdminOffersCpaId: {
    parameters: {
      path: {
        /** The id of the cpa offer */
        id: components["parameters"]["OfferCpaId"];
      };
    };
    responses: {
      /** Success */
      204: never;
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  PatchApiAdminOffersCpaId: {
    parameters: {
      path: {
        /** The id of the cpa offer */
        id: components["parameters"]["OfferCpaId"];
      };
    };
    responses: {
      /** Success */
      204: never;
      /** Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
    requestBody: components["requestBodies"]["OfferCpaAdminPatchBody"];
  };
  GetApiAdminOffersCpaIdAffiliatesRates: {
    parameters: {
      path: {
        /** The id of the cpa offer */
        id: components["parameters"]["OfferCpaId"];
      };
      query: {
        platform: components["parameters"]["OffersCpaRequiredFilterByPlatform"];
        countries?: components["parameters"]["FilterByCountries"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["OfferCpaAffiliateRatesCollection"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiAdminOffersCpaIdRules: {
    parameters: {
      path: {
        /** The id of the cpa offer */
        id: components["parameters"]["OfferCpaId"];
      };
      query: {
        skip?: components["parameters"]["PageSkipParam"];
        /** size of slice */
        first?: components["parameters"]["PageSizeParam"];
        countries?: components["parameters"]["FilterByCountries"];
        platforms?: components["parameters"]["OffersCpaFilterByPlatforms"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["OffersCpaRulesAdminCollection"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  PostApiAdminOffersCpaIdRules: {
    parameters: {
      path: {
        /** The id of the cpa offer */
        id: components["parameters"]["OfferCpaId"];
      };
    };
    responses: {
      /** Success */
      201: unknown;
      /** Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
    requestBody: components["requestBodies"]["OfferCpaRuleAdminPostBody"];
  };
  GetApiAdminOffersCpaIdRulesRuleId: {
    parameters: {
      path: {
        /** The id of the cpa offer */
        id: components["parameters"]["OfferCpaId"];
        /** The id of the cpa offer rule */
        ruleId: components["parameters"]["OfferCpaRuleId"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["OfferCpaRuleAdmin"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  PutApiAdminOffersCpaIdRulesRuleId: {
    parameters: {
      path: {
        /** The id of the cpa offer */
        id: components["parameters"]["OfferCpaId"];
        /** The id of the cpa offer rule */
        ruleId: components["parameters"]["OfferCpaRuleId"];
      };
    };
    responses: {
      /** Success */
      204: never;
      /** Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
    requestBody: components["requestBodies"]["OfferCpaRuleAdminPutBody"];
  };
  DeleteApiAdminOffersCpaIdRulesRuleId: {
    parameters: {
      path: {
        /** The id of the cpa offer */
        id: components["parameters"]["OfferCpaId"];
        /** The id of the cpa offer rule */
        ruleId: components["parameters"]["OfferCpaRuleId"];
      };
    };
    responses: {
      /** Success */
      204: never;
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  PutApiAdminOffersCpaIdTriggers: {
    parameters: {
      path: {
        /** The id of the cpa offer */
        id: components["parameters"]["OfferCpaId"];
      };
    };
    responses: {
      /** Success */
      204: never;
      /** Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
    requestBody: components["requestBodies"]["OfferCpaTriggersAdminBulkPutBody"];
  };
  GetApiAdminOffersId: {
    parameters: {
      path: {
        /** The id of the offer */
        id: components["parameters"]["OfferId"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["OfferAdmin"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  PutApiAdminOffersId: {
    parameters: {
      path: {
        /** The id of the offer */
        id: components["parameters"]["OfferId"];
      };
    };
    responses: {
      /** Success */
      204: never;
      /** Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
    requestBody: components["requestBodies"]["OfferPutBody"];
  };
  GetApiAdminV3Advertisers: {
    parameters: {
      query: {
        /** The id of the site */
        site_id?: components["parameters"]["SiteId"];
        ids?: components["parameters"]["FilterByIds"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["AdvertisersAdminCollectionV3"];
        };
      };
      /** Unauthorized */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiAdminV3AffiliateOffers: {
    parameters: {
      query: {
        /** The id of the affiliate */
        aff_id: components["parameters"]["AffIdV2"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["AffiliateOfferAdminCollectionV3"];
        };
      };
      /** Unauthorized */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  PostApiAdminV3AffiliateOffers: {
    responses: {
      201: components["responses"]["AffiliateOfferAdminPostV3Response"];
      /** Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unauthorized */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
    requestBody: components["requestBodies"]["AffiliateOfferAdminPostV3Body"];
  };
  PatchApiAdminV3AffiliateOffersId: {
    parameters: {
      path: {
        /** The id of the affiliate offer */
        id: components["parameters"]["AffiliateOfferId"];
      };
    };
    responses: {
      /** Success */
      204: never;
      /** Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unauthorized */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
    requestBody: components["requestBodies"]["AffiliateOfferAdminPatchV3Body"];
  };
  GetApiAdminV3ModelsConfigurationsCpa: {
    parameters: {
      query: {
        ids?: components["parameters"]["FilterByIds"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["ModelsConfigurationsCpaCollection"];
        };
      };
      /** Unauthorized */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiAdminV3ModelsConfigurationsLot: {
    parameters: {
      query: {
        ids?: components["parameters"]["FilterByIds"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["ModelsConfigurationsLotCollection"];
        };
      };
      /** Unauthorized */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiAdminV3ModelsConfigurationsRevenue: {
    parameters: {
      query: {
        ids?: components["parameters"]["FilterByIds"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["ModelsConfigurationsRevenueCollection"];
        };
      };
      /** Unauthorized */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiAdminV3ModelsConfigurationsSpread: {
    parameters: {
      query: {
        ids?: components["parameters"]["FilterByIds"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["ModelsConfigurationsSpreadCollection"];
        };
      };
      /** Unauthorized */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiAdminV3Offers: {
    parameters: {
      query: {
        skip?: components["parameters"]["PageSkipParam"];
        /** size of slice */
        first?: components["parameters"]["PageSizeParam"];
        search?: components["parameters"]["OffersSearch"];
        advertisers?: components["parameters"]["OffersFilterByAdvertisers"];
        models?: components["parameters"]["OffersFilterByModelsV3"];
        configuration_ids?: components["parameters"]["OffersFilterByConfigurationId"];
        hide_deleted?: components["parameters"]["FilterByDeletedV2"];
        sort?: components["parameters"]["OffersSortBy"];
        order?: components["parameters"]["SortOrder"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["OffersAdminCollectionV3"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  DeleteApiAdminV3OffersId: {
    parameters: {
      path: {
        /** The id of the offer */
        id: components["parameters"]["OfferId"];
      };
    };
    responses: {
      /** Success */
      204: never;
      /** Unauthorized */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Not found */
      404: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiAdminV4Offers: {
    parameters: {
      query: {
        skip?: components["parameters"]["PageSkipParam"];
        /** size of slice */
        first?: components["parameters"]["PageSizeParam"];
        search?: components["parameters"]["OffersSearch"];
        advertisers?: components["parameters"]["OffersFilterByAdvertisers"];
        models?: components["parameters"]["OffersFilterByModelsV4"];
        hide_deleted?: components["parameters"]["FilterByDeletedV4"];
        sort?: components["parameters"]["OffersSortBy"];
        order?: components["parameters"]["SortOrder"];
        is_trial?: components["parameters"]["IsTrial"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["OffersAdminCollectionV4"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  PostApiAdminV4Offers: {
    responses: {
      /** Success */
      201: {
        content: {
          "application/json": components["schemas"]["OfferV4PostResponse"];
        };
      };
      /** Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
    requestBody: components["requestBodies"]["OfferAdminPostBodyV4"];
  };
  GetApiAdminV4OffersId: {
    parameters: {
      path: {
        /** The id of the offer */
        id: components["parameters"]["OfferId"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["OfferAdminV4"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  PutApiAdminV4OffersId: {
    parameters: {
      path: {
        /** The id of the offer */
        id: components["parameters"]["OfferId"];
      };
    };
    responses: {
      /** Success */
      204: never;
      /** Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
    requestBody: components["requestBodies"]["OfferAdminPutBodyV4"];
  };
  DeleteApiAdminV4OffersId: {
    parameters: {
      path: {
        /** The id of the offer */
        id: components["parameters"]["OfferId"];
      };
    };
    responses: {
      /** Success */
      204: never;
      /** Unauthorized */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Not found */
      404: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiAdminV4OffersIdCpaSettings: {
    parameters: {
      path: {
        /** The id of the offer */
        id: components["parameters"]["OfferId"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["OfferAdminCpaSettingsResponseV4"];
        };
      };
      /** Bad Request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Permission Denied */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  PutApiAdminV4OffersIdCpaSettings: {
    parameters: {
      path: {
        /** The id of the offer */
        id: components["parameters"]["OfferId"];
      };
    };
    responses: {
      /** Success */
      204: never;
      /** Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Permission Denied */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
    requestBody: components["requestBodies"]["OfferAdminCpaSettingsPutBodyV4"];
  };
  GetApiAdminV4OffersIdCpaTriggers: {
    parameters: {
      path: {
        /** The id of the offer */
        id: components["parameters"]["OfferId"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["OfferAdminCpaTriggersResponseV4"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Permission Denied */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  PatchApiAdminV4OffersIdCpaTriggers: {
    parameters: {
      path: {
        /** The id of the offer */
        id: components["parameters"]["OfferId"];
      };
    };
    responses: {
      /** Success */
      204: never;
      /** Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Permission Denied */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
    requestBody: components["requestBodies"]["OfferAdminCpaTriggersPatchBodyV4"];
  };
  GetApiAdminV4OffersIdRevenueLevels: {
    parameters: {
      path: {
        /** The id of the offer */
        id: components["parameters"]["OfferId"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["OfferAdminRevenueLevelsResponseV4"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Permission Denied */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  PatchApiAdminV4OffersIdRevenueLevels: {
    parameters: {
      path: {
        /** The id of the offer */
        id: components["parameters"]["OfferId"];
      };
    };
    responses: {
      /** Success */
      204: never;
      /** Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Permission Denied */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
    requestBody: components["requestBodies"]["OfferAdminRevenueLevelsPatchBodyV4"];
  };
  GetApiAdminV4OffersIdRevenueSettings: {
    parameters: {
      path: {
        /** The id of the offer */
        id: components["parameters"]["OfferId"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["OfferAdminRevenueSettingsResponseV4"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Permission Denied */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  PutApiAdminV4OffersIdRevenueSettings: {
    parameters: {
      path: {
        /** The id of the offer */
        id: components["parameters"]["OfferId"];
      };
    };
    responses: {
      /** Success */
      204: never;
      /** Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Permission Denied */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
    requestBody: components["requestBodies"]["OfferAdminRevenueSettingsPutBodyV4"];
  };
  GetAdminOfferRulesV4: {
    parameters: {
      path: {
        /** The id of the offer */
        id: components["parameters"]["OfferId"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["OfferAdminOfferRulesResponseV4"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Permission Denied */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  DeleteAdminOfferRulesForLocale: {
    parameters: {
      path: {
        /** The id of the offer */
        id: components["parameters"]["OfferId"];
        /** Locale information */
        locale: components["parameters"]["LocaleId"];
      };
    };
    responses: {
      /** Success */
      204: never;
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Permission Denied */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetAdminOfferRuleV4: {
    parameters: {
      path: {
        /** The id of the offer */
        id: components["parameters"]["OfferId"];
        /** The name of the section */
        section: components["parameters"]["SectionId"];
        /** Locale information */
        locale: components["parameters"]["LocaleId"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["OfferAdminRuleItem"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Permission Denied */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  UpdateAdminOfferRuleV4: {
    parameters: {
      path: {
        /** The id of the offer */
        id: components["parameters"]["OfferId"];
        /** The name of the section */
        section: components["parameters"]["SectionId"];
        /** Locale information */
        locale: components["parameters"]["LocaleId"];
      };
    };
    responses: {
      /** Success */
      204: never;
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Permission Denied */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["OfferAdminRuleItem"];
      };
    };
  };
  GetApiAdvertisers: {
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["AdvertisersCollection"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiAdvertisersId: {
    parameters: {
      path: {
        /** The id of the advertiser */
        id: components["parameters"]["AdvertiserId"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["Advertiser"];
        };
      };
      /** Not found */
      404: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiAdvertisersIdAttributes: {
    parameters: {
      path: {
        /** The id of the advertiser */
        id: components["parameters"]["AdvertiserId"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["AdvertiserAttributesCollection"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiAdvertisersIdCountries: {
    parameters: {
      path: {
        /** The id of the advertiser */
        id: components["parameters"]["AdvertiserId"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["AdvertiserCountriesCollection"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiAdvertisersIdModels: {
    parameters: {
      path: {
        /** The id of the offer */
        id: components["parameters"]["OfferId"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["ModelsCollection"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiAffiliateAdvertisersId: {
    parameters: {
      path: {
        /** The id of the advertiser */
        id: components["parameters"]["AdvertiserId"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["AffiliateAdvertiser"];
        };
      };
      /** Not found */
      404: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  PatchApiAffiliateAdvertisersId: {
    parameters: {
      path: {
        /** The id of the advertiser */
        id: components["parameters"]["AdvertiserId"];
      };
    };
    responses: {
      /** Success */
      204: never;
      /** Not found */
      404: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
    requestBody: components["requestBodies"]["AffiliateAdvertiserPatchBody"];
  };
  GetApiModels: {
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["ModelsCollection"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiOffersAvailable: {
    parameters: {
      query: {
        advertiserId?: components["parameters"]["OffersFilterByAdvertiser"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["OffersCollection"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiOffersUnavailable: {
    parameters: {
      query: {
        advertiserId?: components["parameters"]["OffersFilterByAdvertiser"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["OffersCollection"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiOffersId: {
    parameters: {
      path: {
        /** The id of the offer */
        id: components["parameters"]["OfferId"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["Offer"];
        };
      };
      /** Not found */
      404: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiOffersIdActivation: {
    parameters: {
      path: {
        /** The id of the offer */
        id: components["parameters"]["OfferId"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["OfferActivation"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiOffersIdAdvertiser: {
    parameters: {
      path: {
        /** The id of the offer */
        id: components["parameters"]["OfferId"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["OfferAdvertiser"];
        };
      };
      /** Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Not found */
      404: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiOffersIdCpaRates: {
    parameters: {
      path: {
        /** The id of the cpa offer */
        id: components["parameters"]["OfferCpaId"];
      };
      query: {
        platform: components["parameters"]["OffersCpaRequiredFilterByPlatform"];
        countries?: components["parameters"]["FilterByCountries"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["OfferCpaAffiliateRatesCollection"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  PostApiOffersIdMarketingRulesAccept: {
    parameters: {
      path: {
        /** The id of the offer */
        id: components["parameters"]["OfferId"];
      };
    };
    responses: {
      /** Success */
      201: unknown;
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiOffersIdRates: {
    parameters: {
      path: {
        /** The id of the offer */
        id: components["parameters"]["OfferId"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["OfferRatesCollection"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  PostApiOffersIdTrafficSources: {
    parameters: {
      path: {
        /** The id of the offer */
        id: components["parameters"]["OfferId"];
      };
    };
    responses: {
      /** Success */
      201: unknown;
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
    requestBody: components["requestBodies"]["OfferActivationTrafficSourcesPostBody"];
  };
  GetApiV2Offers: {
    parameters: {
      query: {
        /** for favourite list */
        isFavourite?: components["parameters"]["OffersFilterByIsFavourite"];
        status?: components["parameters"]["OffersFilterByAvailabilityStatus"];
        advertiserIds?: components["parameters"]["OffersFilterByAdvertiserIds"];
        modelId?: components["parameters"]["OffersFilterByModels"];
        regions?: components["parameters"]["OffersFilterByRegions"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["OffersCollectionV2"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiV2OffersActivations: {
    parameters: {
      query: {
        advertiserIds?: components["parameters"]["OffersFilterByAdvertiserIds"];
        modelId?: components["parameters"]["OffersFilterByModels"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["OffersActivationsCollection"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  PostApiV2OffersFavorite: {
    responses: {
      /** Success */
      204: never;
      /** Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Permission Denied */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
    requestBody: components["requestBodies"]["OfferIdPostBody"];
  };
  DeleteApiV2OffersFavorite: {
    responses: {
      /** Success */
      204: never;
      /** Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Permission Denied */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
    requestBody: components["requestBodies"]["OfferIdPostBody"];
  };
  GetApiV2OffersAdvertModel: {
    parameters: {
      path: {
        /** Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa'] */
        AdvertModel: components["parameters"]["AdvertModel"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["Offer"];
        };
      };
      /** Not found */
      404: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiV2OffersAdvertModelActivation: {
    parameters: {
      path: {
        /** Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa'] */
        AdvertModel: components["parameters"]["AdvertModel"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["OfferActivation"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiV2OffersAdvertModelAdvertiser: {
    parameters: {
      path: {
        /** Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa'] */
        AdvertModel: components["parameters"]["AdvertModel"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["OfferAdvertiser"];
        };
      };
      /** Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Not found */
      404: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiV2OffersAdvertModelCpaRates: {
    parameters: {
      path: {
        /** Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa'] */
        AdvertModel: components["parameters"]["AdvertModel"];
      };
      query: {
        platform: components["parameters"]["OffersCpaRequiredFilterByPlatform"];
        countries?: components["parameters"]["FilterByCountries"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["OfferCpaAffiliateRatesCollection"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiV2OffersAdvertModelCpaTriggers: {
    parameters: {
      path: {
        /** Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa'] */
        AdvertModel: components["parameters"]["AdvertModel"];
      };
      query: {
        platform: components["parameters"]["OffersCpaRequiredFilterByPlatform"];
        countries?: components["parameters"]["FilterByCountries"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["OfferCpaTriggersResponseV2"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  PostApiV2OffersAdvertModelMarketingRulesAccept: {
    parameters: {
      path: {
        /** Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa'] */
        AdvertModel: components["parameters"]["AdvertModel"];
      };
    };
    responses: {
      /** Success */
      201: unknown;
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiV2OffersAdvertModelRates: {
    parameters: {
      path: {
        /** Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa'] */
        AdvertModel: components["parameters"]["AdvertModel"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["OfferRatesCollection"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiV2OffersAdvertModelRevenueRatedView: {
    parameters: {
      path: {
        /** Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa'] */
        AdvertModel: components["parameters"]["AdvertModel"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["OfferRevenueRatedView"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetOfferRules: {
    parameters: {
      path: {
        /** Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa'] */
        AdvertModel: components["parameters"]["AdvertModel"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["OfferRulesResponse"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Permission Denied */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetOfferRule: {
    parameters: {
      path: {
        /** Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa'] */
        AdvertModel: components["parameters"]["AdvertModel"];
        /** The name of the section */
        section: components["parameters"]["SectionId"];
        /** Locale information */
        locale: components["parameters"]["LocaleId"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["OfferRuleItem"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Permission Denied */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  PostApiV2OffersAdvertModelTrafficSources: {
    parameters: {
      path: {
        /** Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa'] */
        AdvertModel: components["parameters"]["AdvertModel"];
      };
    };
    responses: {
      /** Success */
      201: unknown;
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
    requestBody: components["requestBodies"]["OfferActivationTrafficSourcesPostBody"];
  };
  GetHealthcheck: {
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["Healthcheck"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
}

export interface external {}

export enum ApiPaths {
  GetApiAdminAdvertisers = "/api/admin/advertisers",
  GetApiAdminAffiliateOffers = "/api/admin/affiliate-offers",
  PostApiAdminAffiliateOffers = "/api/admin/affiliate-offers",
  GetApiAdminAffiliateOffersId = "/api/admin/affiliate-offers/:id",
  PatchApiAdminAffiliateOffersId = "/api/admin/affiliate-offers/:id",
  GetApiAdminModels = "/api/admin/models",
  GetApiAdminOffers = "/api/admin/offers",
  PostApiAdminOffers = "/api/admin/offers",
  GetApiAdminOffersCpa = "/api/admin/offers-cpa",
  PostApiAdminOffersCpa = "/api/admin/offers-cpa",
  PostApiAdminOffersCpaClone = "/api/admin/offers-cpa-clone",
  GetApiAdminOffersCpaCategoriesWeights = "/api/admin/offers-cpa/categories-weights",
  DeleteApiAdminOffersCpaId = "/api/admin/offers-cpa/:id",
  GetApiAdminOffersCpaId = "/api/admin/offers-cpa/:id",
  PatchApiAdminOffersCpaId = "/api/admin/offers-cpa/:id",
  GetApiAdminOffersCpaIdAffiliatesRates = "/api/admin/offers-cpa/:id/affiliates-rates",
  GetApiAdminOffersCpaIdRules = "/api/admin/offers-cpa/:id/rules",
  PostApiAdminOffersCpaIdRules = "/api/admin/offers-cpa/:id/rules",
  DeleteApiAdminOffersCpaIdRulesRuleId = "/api/admin/offers-cpa/:id/rules/:ruleId",
  GetApiAdminOffersCpaIdRulesRuleId = "/api/admin/offers-cpa/:id/rules/:ruleId",
  PutApiAdminOffersCpaIdRulesRuleId = "/api/admin/offers-cpa/:id/rules/:ruleId",
  PutApiAdminOffersCpaIdTriggers = "/api/admin/offers-cpa/:id/triggers",
  GetApiAdminOffersId = "/api/admin/offers/:id",
  PutApiAdminOffersId = "/api/admin/offers/:id",
  GetApiAdminV3Advertisers = "/api/admin/v3/advertisers",
  GetApiAdminV3AffiliateOffers = "/api/admin/v3/affiliate-offers",
  PostApiAdminV3AffiliateOffers = "/api/admin/v3/affiliate-offers",
  PatchApiAdminV3AffiliateOffersId = "/api/admin/v3/affiliate-offers/:id",
  GetApiAdminV3ModelsConfigurationsCpa = "/api/admin/v3/models-configurations/cpa",
  GetApiAdminV3ModelsConfigurationsLot = "/api/admin/v3/models-configurations/lot",
  GetApiAdminV3ModelsConfigurationsRevenue = "/api/admin/v3/models-configurations/revenue",
  GetApiAdminV3ModelsConfigurationsSpread = "/api/admin/v3/models-configurations/spread",
  GetApiAdminV3Offers = "/api/admin/v3/offers",
  DeleteApiAdminV3OffersId = "/api/admin/v3/offers/:id",
  GetApiAdminV4Offers = "/api/admin/v4/offers",
  PostApiAdminV4Offers = "/api/admin/v4/offers",
  DeleteApiAdminV4OffersId = "/api/admin/v4/offers/:id",
  GetApiAdminV4OffersId = "/api/admin/v4/offers/:id",
  PutApiAdminV4OffersId = "/api/admin/v4/offers/:id",
  GetApiAdminV4OffersIdCpaSettings = "/api/admin/v4/offers/:id/cpa/settings",
  PutApiAdminV4OffersIdCpaSettings = "/api/admin/v4/offers/:id/cpa/settings",
  GetApiAdminV4OffersIdCpaTriggers = "/api/admin/v4/offers/:id/cpa/triggers",
  PatchApiAdminV4OffersIdCpaTriggers = "/api/admin/v4/offers/:id/cpa/triggers",
  GetApiAdminV4OffersIdRevenueLevels = "/api/admin/v4/offers/:id/revenue/levels",
  PatchApiAdminV4OffersIdRevenueLevels = "/api/admin/v4/offers/:id/revenue/levels",
  GetApiAdminV4OffersIdRevenueSettings = "/api/admin/v4/offers/:id/revenue/settings",
  PutApiAdminV4OffersIdRevenueSettings = "/api/admin/v4/offers/:id/revenue/settings",
  GetAdminOfferRulesV4 = "/api/admin/v4/offers/:id/rules",
  DeleteAdminOfferRulesForLocale = "/api/admin/v4/offers/:id/rules/:locale",
  GetAdminOfferRuleV4 = "/api/admin/v4/offers/:id/rules/:section/:locale",
  UpdateAdminOfferRuleV4 = "/api/admin/v4/offers/:id/rules/:section/:locale",
  GetApiAdvertisers = "/api/advertisers",
  GetApiAdvertisersId = "/api/advertisers/:id",
  GetApiAdvertisersIdAttributes = "/api/advertisers/:id/attributes",
  GetApiAdvertisersIdCountries = "/api/advertisers/:id/countries",
  GetApiAdvertisersIdModels = "/api/advertisers/:id/models",
  GetApiAffiliateAdvertisersId = "/api/affiliate-advertisers/:id",
  PatchApiAffiliateAdvertisersId = "/api/affiliate-advertisers/:id",
  GetApiModels = "/api/models",
  GetApiOffersAvailable = "/api/offers/available",
  GetApiOffersUnavailable = "/api/offers/unavailable",
  GetApiOffersId = "/api/offers/:id",
  GetApiOffersIdActivation = "/api/offers/:id/activation",
  GetApiOffersIdAdvertiser = "/api/offers/:id/advertiser",
  GetApiOffersIdCpaRates = "/api/offers/:id/cpa-rates",
  PostApiOffersIdMarketingRulesAccept = "/api/offers/:id/marketing-rules-accept",
  GetApiOffersIdRates = "/api/offers/:id/rates",
  PostApiOffersIdTrafficSources = "/api/offers/:id/traffic-sources",
  GetApiV2Offers = "/api/v2/offers",
  GetApiV2OffersActivations = "/api/v2/offers/activations",
  DeleteApiV2OffersFavorite = "/api/v2/offers/favorite",
  PostApiV2OffersFavorite = "/api/v2/offers/favorite",
  GetApiV2OffersAdvertModel = "/api/v2/offers/:AdvertModel",
  GetApiV2OffersAdvertModelActivation = "/api/v2/offers/:AdvertModel/activation",
  GetApiV2OffersAdvertModelAdvertiser = "/api/v2/offers/:AdvertModel/advertiser",
  GetApiV2OffersAdvertModelCpaRates = "/api/v2/offers/:AdvertModel/cpa-rates",
  GetApiV2OffersAdvertModelCpaTriggers = "/api/v2/offers/:AdvertModel/cpa-triggers",
  PostApiV2OffersAdvertModelMarketingRulesAccept = "/api/v2/offers/:AdvertModel/marketing-rules-accept",
  GetApiV2OffersAdvertModelRates = "/api/v2/offers/:AdvertModel/rates",
  GetApiV2OffersAdvertModelRevenueRatedView = "/api/v2/offers/:AdvertModel/revenue-rated-view",
  GetOfferRules = "/api/v2/offers/:AdvertModel/rules",
  GetOfferRule = "/api/v2/offers/:AdvertModel/rules/:section/:locale",
  PostApiV2OffersAdvertModelTrafficSources = "/api/v2/offers/:AdvertModel/traffic-sources",
  GetHealthcheck = "/healthcheck",
}
